// extracted by mini-css-extract-plugin
export default {"powered-by":"PoweredByKey_powered-by__ly0b8","key-logo":"PoweredByKey_key-logo__Dq6BC"};